const PLACEHOLDER_BUSINESS_ROLES = ["Sales representative", "Marketing"];
/**
 * Business roles (a user's function in the organisation, e.g. "Marketing"), unrelated to the
 * access roles of `RolesService`.
 *
 * CONSTRAINT: no backend stores business roles yet, so every user gets the same placeholder
 * values. Replace this adapter with a BFF-backed one before the screen ships to customers.
 */
export class MockBusinessRolesService {
    async listForUser(_userId) {
        return [...PLACEHOLDER_BUSINESS_ROLES];
    }
}
